import { render, staticRenderFns } from "./PreviewGroupQType1.vue?vue&type=template&id=803ae606&scoped=true&"
import script from "./PreviewGroupQType1.vue?vue&type=script&lang=js&"
export * from "./PreviewGroupQType1.vue?vue&type=script&lang=js&"
import style0 from "./PreviewGroupQType1.vue?vue&type=style&index=0&id=803ae606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803ae606",
  null
  
)

export default component.exports